module.exports = __webpack_public_path__ + "img/attach.5c87b543.svg";